export default "__VITE_ASSET__BpVcIib$__"